// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__jJ6Vb","content":"Consent_content__1vgNF","footer":"Consent_footer__xifLH"};